import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

export default function ImportHistory({ imports }) {
  if (!imports.length) return <Typography sx={{ mt: 2 }}>No imports yet.</Typography>;
  return (
    <TableContainer sx={{ mt: 2 }}>
      <Table size="small" aria-label="ECG import history">
        <TableHead>
          <TableRow>
            {[
              'Import',
              'Import date',
              'Range',
              'Files selected',
              'Uploaded',
              'Success',
              'Failed',
              'Status',
            ].map((label) => (
              <TableCell key={label}>{label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {imports.map((entry) => (
            <TableRow key={entry.id}>
              <TableCell>#{entry.number}</TableCell>
              <TableCell>{entry.date}</TableCell>
              <TableCell>
                {Number.isInteger(entry.rangeStart) ? `${entry.rangeStart}–${entry.rangeEnd}` : '—'}
              </TableCell>
              <TableCell>
                {entry.total}
                {entry.available > entry.total && ` of ${entry.available} found`}
                {entry.skipped > 0 && ` (${entry.skipped} unrelated skipped)`}
              </TableCell>
              <TableCell>{entry.uploaded}</TableCell>
              <TableCell>{entry.success}</TableCell>
              <TableCell>
                {entry.failed}
                {entry.errors.length > 0 && (
                  <Box component="details">
                    <summary>Failure details</summary>
                    {entry.errors.map((error, index) => (
                      <Typography
                        variant="body2"
                        key={`${error.path}:${index}`}
                        sx={{ overflowWrap: 'anywhere' }}
                      >
                        {error.path}: {error.message}
                      </Typography>
                    ))}
                  </Box>
                )}
              </TableCell>
              <TableCell>
                {entry.status}
                {entry.status !== 'Importing' &&
                  entry.total > entry.success + entry.failed &&
                  ` (${entry.total - entry.success - entry.failed} not processed)`}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
ImportHistory.propTypes = { imports: PropTypes.array.isRequired };
